<template>
  <v-overlay
    :value="isCargando"
    absolute
    z-index="99999">
    <v-progress-circular
      :size="100"
      :width="15"
      indeterminate>
    </v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SeEstaCargando',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isCargando: 'configuracion/isCargando',
    }),
  },
};
</script>

<style lang="scss">
</style>
